import { render } from "./edit-profile.vue?vue&type=template&id=69120dfc&scoped=true"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"

import "./edit-profile.vue?vue&type=style&index=0&id=69120dfc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69120dfc"]])

export default __exports__